// Canvas charts cannot read CSS variables, so resolve tokens against the workshop shell.
export function cssVar(name, fallback = '') {
  if (typeof document === 'undefined') return fallback
  const scope = document.querySelector('.app-shell') || document.documentElement
  return getComputedStyle(scope).getPropertyValue(name).trim() || fallback
}

export function chartTheme() {
  return {
    axis: cssVar('--chart-axis', '#9AA3AD'),
    grid: cssVar('--row-divider', '#262B31'),
    dimmed: cssVar('--field-border', '#363D45'),
    series: ['--chart-1', '--chart-2', '--chart-3', '--chart-4'].map(name => cssVar(name)),
  }
}
